import CreateAccount from "../../components/CreateAccount";

const Registration = () => {
  return (
    <div style={{ maxWidth: 459, width: "100%" }}>
      <CreateAccount />
    </div>
  );
};

export default Registration;
